module.exports = __webpack_public_path__ + "static/media/project_design_1_3.2ad479d5.webp";